// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import I18n from 'i18n-js';

import { get } from 'lodash';
import React from 'react';

import { EVERYWHERE_CODE } from './shared/constants';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import * as Geo from '../lib/geo';

import LocalePickerButton from './locale_picker/locale_picker_button';
import URLHelpers from './shared/url_helpers';
import {
  ShippingWarningData,
} from '@reverbdotcom/commons/src/gql/graphql';

import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { RCAlertBox } from '@reverbdotcom/cadence/components';

interface IProps extends IUserContext {
  listing: ShippingWarningData.Fragment;
}

function sellerUuid(props: IProps): string {
  return get(props, 'listing.shop.userUuid', '');
}

function itemIdSlug(props: IProps): string {
  return `${props.listing.id}-${props.listing.slug}`;
}

function contact(props: IProps): string {
  const href = URLHelpers.newDashboardMessagesPath(itemIdSlug(props), sellerUuid(props));

  return I18n.t('discovery.item2ShippingWarning.contact', {
    linkOpen: `<a href="${href}">`,
    linkClose: '</a>',
  });
}

function shouldRender(props: IProps): boolean {
  if (props.user.shippingRegionCode === EVERYWHERE_CODE) return false;
  if (props.listing.shipping?.localPickupOnly) return false;

  return get(props, 'listing.shipping.shippingPrices[0]', undefined) === undefined;
}

export function Item2ShippingWarning(props: IProps) {
  if (!shouldRender(props)) return null;

  return (
    <div className="align-center scaling-mtb-4">
      <RCAlertBox type="plain">
        <SanitizedRender
          htmlTag="p"
          className="size-80"
          html={
            I18n.t('discovery.item2ShippingWarning.message',
              {
                contact: contact(props),
                shippingCountry: Geo.shippingRegionName(props.user.shippingRegionCode),
              },
            )
          }
        />
        <LocalePickerButton className="button button--small">
          {I18n.t('discovery.item2ShippingWarning.changeShippingRegion')}
        </LocalePickerButton>
      </RCAlertBox>
    </div>
  );
}

export default withUserContext(Item2ShippingWarning);

export const ShippingWarningFragment = gql`
fragment ShippingWarningData on Listing {
  _id
  id
  slug
  shipping {
    localPickupOnly
    shippingPrices {
      _id
      shippingMethod
      carrierCalculated
      destinationPostalCodeNeeded
      rate {
        amount
        amountCents
        currency
        display
      }
    }
  }
  shop {
    _id
    userUuid
  }
}`;
